import { max, min } from 'd3-array';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { bandScale, ordinalScale } from '../../../factory/scales';

import rawData from './data/data.json';

const keys = ['2024', '2025'];
const cities = [...new Set(rawData.map(d => d.location))].sort();

export { cities };

export default function (props) {
  const { initialWidth, isMobile, selectedCity } = props;

  const filteredData = rawData
    .filter(d => d.location === selectedCity && d.crime !== 'All Crimes')
    .map(d => ({
      ...d,
      2024: Number(d['2024']),
      2025: Number(d['2025']),
    }));

  const margins = {
    top: 0,
    right: 50,
    bottom: 20,
    left: isMobile ? 90 : 150,
  };

  const barHeight = 30;
  const padding = 0.1;

  const width = initialWidth - margins.right - margins.left;
  const height = (filteredData.length * keys.length) * (barHeight + (padding * barHeight));

  const maxValue = max(filteredData, d => max(keys, key => d[key]));
  const minValue = min(filteredData, d => min(keys, key => d[key]));

  const xTickCount = isMobile ? 3 : 5;

  const xAxisConfig = {
    orientation: 'bottom',
    domain: [Math.min(0, minValue), maxValue],
    range: [0, width],
    nice: xTickCount,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: filteredData.map(d => d.crime),
    range: [0, height],
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y0 } = bandAxis(yAxisConfig);

  const y1 = bandScale({
    domain: keys,
    range: [0, y0.bandwidth()],
    padding,
  });

  const colorScale = ordinalScale({
    domain: keys,
    range: ['#53A796', '#086b5c'],
  });

  return {
    colorScale,
    data: filteredData,
    height,
    initialWidth,
    initialHeight: height + margins.top + margins.bottom,
    keys,
    margins,
    width,
    xAxis,
    x,
    yAxis,
    y0,
    y1,
  };
}
